import { ProductCategory } from '@repo/shared-types';
import { Button } from '@repo/ui/components/button';
import { OptionsGrid } from './options-grid';

interface CategorySelectionStepProps {
  categories: ProductCategory[];
  onSelectCategory: (categoryId: string) => void;
}

export function CategorySelectionStep({
  categories,
  onSelectCategory,
}: CategorySelectionStepProps) {
  if (categories.length === 0) {
    return (
      <div className="flex flex-col gap-4 items-center justify-center py-8">
        <p className="text-gray-500 text-center">No hay categorías disponibles con productos</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto">
      <OptionsGrid>
        {categories.map((category) => (
          <Button
            key={category.id}
            variant="pos-outline"
            onClick={() => onSelectCategory(category.id)}
          >
            <div className="flex flex-col items-center justify-center gap-2 h-full">
              <div className="text-4xl! font-bold!">{category.name}</div>
              {category.description && (
                <div className="text-lg! font-normal">{category.description}</div>
              )}
            </div>
          </Button>
        ))}
      </OptionsGrid>
    </div>
  );
}
